/* Created by Interactive 63 - https://interactive63.com */
/**
 * Identifier generation. Tracks, keyframes and projects get short random IDs; elements get
 * sequential IDs assigned during import so they stay stable and readable in exported CSS.
 */

const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';
const ID_LENGTH = 8;
// Bytes at or above this value are discarded so every character is equally likely.
const BYTE_LIMIT = 252;

/** Returns a short unique ID such as `kf_k3x9a2b1`, using the given prefix. */
export function createId(prefix: string): string {
  let suffix = '';
  while (suffix.length < ID_LENGTH) {
    const bytes = crypto.getRandomValues(new Uint8Array(ID_LENGTH));
    for (const byte of bytes) {
      if (byte < BYTE_LIMIT && suffix.length < ID_LENGTH) suffix += ALPHABET.charAt(byte % 36);
    }
  }
  return `${prefix}_${suffix}`;
}

/** Returns the element ID for a one-based index: 1 becomes "e1". */
export function elementIdFromIndex(n: number): string {
  return `e${n}`;
}
